import script from "./ConfigManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigManager.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigManager.vue?vue&type=style&index=0&id=49a284e7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a284e7"]])

export default __exports__